import React, { useState, useEffect } from 'react'
import { Anchor } from 'Components/Anchor/Anchor'
import classNames from 'classnames'
import { isMobile } from 'Utils/Misc'

export const SubMenuItem = ({ item, isActive, classes, onClick }) => {
  const content = (
    <div
      className={classNames(classes.subItem, {
        [classes.subItemActive]: isActive,
      })}
      onClick={onClick}
    >
      <span className={classes.subItemText}>{item.name}</span>
    </div>
  )

  if (item.href) {
    return (
      <Anchor href={item.href} className={classes.subItemLink}>
        {content}
      </Anchor>
    )
  }

  return content
}

const MenuItemContent = ({ item, isActive, open, classes, hasActiveChild }) => {
  const isClosedWithChildren = item.subLinks && hasActiveChild && !open
  const isActiveWithoutChildren = isActive && !item.subLinks
  const isParentActive = isClosedWithChildren || isActiveWithoutChildren

  return (
    <div className={classes.item}>
      <div
        className={classNames(classes.logoWrap, {
          [classes.active]: isParentActive,
        })}
      >
        {React.cloneElement(item.icon, { isActive: isParentActive })}

        {open && (
          <div
            className={classNames(classes.nameWrap, {
              [classes.activeText]: isActive && !item.subLinks,
            })}
          >
            {item.name}
          </div>
        )}
      </div>
    </div>
  )
}

const MenuItem = ({
  item,
  isActive,
  open,
  setOpen,
  classes,
  currentPath,
  onSetActiveElement,
}) => {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false)

  const hasActiveChild =
    item.subLinks && item.subLinks.some(subLink => subLink.href === currentPath)

  useEffect(() => {
    if (hasActiveChild && !isSubmenuOpen) {
      setIsSubmenuOpen(true)
    }
  }, [hasActiveChild, currentPath, open])

  const handleClick = event => {
    if (item.subLinks) {
      event.preventDefault()
      event.stopPropagation()
      setIsSubmenuOpen(!isSubmenuOpen)
    } else {
      if (item.onClick) {
        item.onClick(event)
      }
      if (isMobile) {
        setOpen(false)
      }
    }
  }

  const handleSubItemClick = (subLink, event) => {
    const isCtrlClick = event.ctrlKey || event.metaKey
    if (!isCtrlClick) {
      onSetActiveElement(item.type)
    }
    if (subLink.onClick) {
      subLink.onClick(event)
    }
  }

  const content = (
    <MenuItemContent
      item={item}
      isActive={isActive}
      open={open}
      classes={classes}
      hasActiveChild={hasActiveChild}
    />
  )

  return (
    <React.Fragment>
      {renderMenuItem.call(this, item, handleClick, classes, content)}

      {isSubmenuOpen && item.subLinks && open && (
        <div className={classes.submenuContainer}>
          {item.subLinks.map(subLink => (
            <SubMenuItem
              key={subLink.name}
              item={subLink}
              isActive={subLink.href === currentPath}
              classes={classes}
              onClick={e => handleSubItemClick(subLink, e)}
            />
          ))}
        </div>
      )}
    </React.Fragment>
  )
}

const renderMenuItem = function(item, handleClick, classes, content) {
  return item.href ? (
    <Anchor href={item.href} onClick={handleClick} className={classes.link}>
      {content}
    </Anchor>
  ) : (
    <div onClick={handleClick}>{content}</div>
  )
}

export default MenuItem
